import { MallApi } from "@/api/MallApi";

const mallApi = new MallApi();

const basicUrl = '/gw/app'

const homePageUrl = {
  jdmp: {
    getHomePageData: basicUrl + '/lywl/employee/scenery/getPage'
  },
  lywl: {
    getHomePageData: basicUrl + '/lywl/employee/activity/list'
  }
}

const bannerUrl = basicUrl + '/lywl/employee/home/banner'

const conditionUrl = basicUrl + '/lywl/employee/home/queryCondition'

export const loadPageData = (params: any) => {
  return mallApi.Post(homePageUrl[params?.curTopic == 1 ? 'jdmp' : 'lywl'].getHomePageData, params, {
    cacheData: false,
  })
}

export const bannerData = (params: any) => {
  return mallApi.Post(bannerUrl, params, {
    cacheData: false,
  })
}

export const conditionData = (params: any) => {
  return mallApi.Post(conditionUrl, params, {
    cacheData: false,
  })
}
